import { Http } from '../helpers'

export const ComplaintService = {
  async search(params) {
    return await Http.get('/complaint', { params: params })
  },
  async autocomplete() {
    return await Http.get('/complaint/autocomplete')
  },
  async view(id) {
    return await Http.get('/complaint/' + id)
  },
  async getStatus(id) {
    return await Http.get('/complaint/complaint-status')
  },
  async getGroups(id) {
    return await Http.get('/complaint/groups')
  },
  async cancel(id) {
    return await Http.put('/complaint/' + id + '/cancel')
  },
  async create(id, params) {
    return await Http.post('/complaint', params)
  },
  async update(id, params) {
    return await Http.put('/complaint/' + id, params)
  },
  async setStatus(id, params) {
    return await Http.put('/complaint/' + id + '/set-status', params)
  },
}
